import CornerTriangle from './CornerTriangle.jsx';

export default CornerTriangle;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/CornerTriangle/index.js